import { render, staticRenderFns } from "./testimonials_info.vue?vue&type=template&id=473b8a36&scoped=true"
import script from "./testimonials_info.vue?vue&type=script&lang=js"
export * from "./testimonials_info.vue?vue&type=script&lang=js"
import style0 from "./testimonials_info.vue?vue&type=style&index=0&id=473b8a36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b8a36",
  null
  
)

export default component.exports